export default {"src":"/org/_next/static/media/calendar.50aeaf1b.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};